<template>
  <!--
      	作者：luoyiming
      	时间：2019-06-04
      	描述：插件中心-优惠券-优惠券列表-修改优惠券
      -->
  <div v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">

      <div class="common-form">基本信息</div>
      <el-form-item label="卡包类型">
       <el-radio-group v-model="form.coupon_type">
         <el-radio :label="10">满减券</el-radio>
         <el-radio :label="20">折扣券</el-radio>
      <!--    <el-radio :label="30">提货卡</el-radio>-->
         <el-radio :label="50">会员专享券</el-radio>
         <el-radio :label="60">指定商品</el-radio>
         <!-- <el-radio label="70">银砖专享</el-radio>
         <el-radio label="80">金砖专享</el-radio> -->
       </el-radio-group>
      </el-form-item>
      <el-form-item label="卡包名称" prop="name" :rules="[{ required: true, message: ' ' }]">
        <el-input v-model="form.name" placeholder="请输入卡包名称"></el-input>
        <div class="tips">例如：满100减10</div>
      </el-form-item>

      <el-form-item label="卡包背景图">
        <div v-if="form.bgImage" class="default-image-box" @click="bgUpload('bg')">
          <div class="image-box">
            <img :src="form.bgImage.file_path" alt="bgImage">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteBgImg('bg')" >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="bgUpload('bg')"><i class="el-icon-plus"></i></div>
        </div>
        <div class="lh18 mt10 gray9">
          <p>推荐尺寸：显示图片长宽为 1000×600</p>
        </div>
      </el-form-item>
      <el-form-item label="分享封面">
        <div v-if="form.shareImage" class="default-image-box" @click="bgUpload('share')">
          <div class="image-box">
            <img :src="form.shareImage.file_path" alt="shareImage">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteBgImg('share')" >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="bgUpload('share')"><i class="el-icon-plus"></i></div>
        </div>
        <div class="lh18 mt10 gray9">
          <p>尺寸：显示图片长宽为 500×400</p>
        </div>
      </el-form-item>
      <el-form-item label="兑换背景" v-if="form.coupon_type==30">
        <div v-if="form.exchange_bg" class="default-image-box" @click="bgUpload('exchange_bg')">
          <div class="image-box">
            <img :src="form.exchange_bg" alt="exchange_bg">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteBgImg('exchange_bg')" >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="bgUpload('exchange_bg')"><i class="el-icon-plus"></i></div>
        </div>
        <div class="lh18 mt10 gray9">
          <p>建议尺寸：750*1334</p>
        </div>
      </el-form-item>
      <div  v-if="form.coupon_type==30">
        <el-form-item label="限制兑换时间">
          <el-radio-group v-model="form.exchange_type">
            <el-radio :label="0">不限制</el-radio>
            <el-radio :label="10">限制</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有效兑换时间" v-if="form.exchange_type==10">
          <el-date-picker
            v-model="form.exchange_time"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="兑换开始时间"
            end-placeholder="兑换结束时间"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            :picker-options="pickerOptions"
            >
          </el-date-picker>
          </el-form-item>
      </div>
      

      <el-form-item label="选择归属分销商" v-if="form.coupon_type == 30">
          <div class="d-s-s d-c">
            <el-button @click="openGetuser" icon="el-icon-plus">选择分销商</el-button>
            <ul class="d-s-s select-user"  v-if="referee">
              <li class="mr10 d-c-c d-c p-10-0" >
                  <img :src="referee.avatarUrl" class="radius" width="30" height="30" />
                  <p class="lh18 ww100 text-ellipsis">{{referee.nickName}}</p>
              </li>
              <li class="mr10 d-c-c d-c p-10-0" @click="deleteReferee">
                  删除
              </li>
            </ul>
          </div>
        </el-form-item>

      <el-form-item label="卡包颜色">
        <el-radio-group v-model="form.color">
          <el-radio :label="10">蓝色</el-radio>
          <el-radio :label="20">红色</el-radio>
          <el-radio :label="30">紫色</el-radio>
          <el-radio :label="40">黄色</el-radio>
           <el-radio :label="50">黄色</el-radio>
           <el-radio :label="60">紫色</el-radio>
          <el-radio label="70">黄色</el-radio>
          <el-radio label="80">紫色</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="到期类型">
        <el-radio-group v-model="form.expire_type">
          <el-radio :label="10">领取后生效</el-radio>
          <el-radio :label="20">固定时间</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if="Number(form.expire_type) === 10">
        <el-form-item label="有效天数">
          <el-input v-model="form.expire_day" placeholder="请输入有效天数" type="number"></el-input>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item label="有效时间">
          <el-date-picker v-model="form.active_time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
      </div>

        <el-form-item label="是否开启分享优惠券" v-if="form.coupon_type != 50">
        <el-radio-group v-model="form.is_share">
          <el-radio :label="0">不开启</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="是否为下单赠送优惠券" v-if="form.coupon_type != 50">
        <el-radio-group v-model="form.is_order_give">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>

          
            <!-- <el-form-item label="是否开启消耗额度" >
        <el-radio-group v-model="form.is_open_ed">
          <el-radio :label="0">不开启</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>

        <div>消耗的额度为抵扣的金额</div>
      </el-form-item> -->

  <div>
    <!-- 关联商品 -->
    <div class="common-form mt50">关联设置</div>
    <el-form-item size="small" label="关联商品">
      <el-button icon="el-icon-plus" @click="changeProduct(form.products)">选择关联商品</el-button>
      <div class="pb50">
        <el-table size="small" :data="form.products" border>
          <el-table-column label="图片" width="60">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic">
                  <img width="30px" height="30px" v-img-url="scope.row.product_image" alt="product_image"/></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="product_name" label="商品"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="deleteClick(scope.$index)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>
    <!--商品选择-->
    <Product :isproduct="isproduct" :excludeIds="excludeIds" :islist="true" @closeDialog="closeDialogFunc"></Product>

  </div>
  



      <span v-if="Number(form.coupon_type)  === 40">
        <div >
        <el-form-item label="充值卡激活赠送卡余额">
          <el-input v-model="form.price" :disabled="true" placeholder="请输入充值卡激活赠送卡余额" type="number"></el-input>
          </el-form-item>
        </div>

        <div >
          <el-form-item label="充值卡激活费用">
            <el-input v-model="form.nprice" :disabled="true" placeholder="请输入充值卡激活费用" type="number"></el-input>
          </el-form-item>
        </div>
      </span>
    

      <!--添加门店-->
      <Pickup :form="form" v-if="Number(form.coupon_type) === 30" :type="'edit'"></Pickup>
      <Coupon :form="form" v-else-if="Number(form.coupon_type) != 40"></Coupon>

      <el-form-item label="使用说明" v-if="form.coupon_type!=40 ">
        <div class="edit_container">
          <Uediter :text="form.content" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc"></Uediter>
        </div>
      </el-form-item>
       <!--选择用户-->
    <GetUser :is_open="open_getuser"  @close="closeGetuserFunc"></GetUser>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="info" size="small" @click="cancelFunc" :loading="loading">取消</el-button>
        <el-button type="primary" size="small" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

    <!--详情附加图片组件-->
    <Upload v-if="isBgUpload" :config="{ total: 9 }" :isupload="isBgUpload" @returnImgs="returnBgImgFunc">上传图片</Upload>
  </div>
</template>

<script>
import CouponApi from '@/api/coupon.js'
import {formatModel} from '@/utils/base.js'
import {mergeTable} from '@/utils/table.js'
import Coupon from "./part/Coupon"
import Pickup from "./part/Pickup"
import Upload from "@/components/file/Upload"
import Uediter from '@/components/UE.vue'
import GetUser from '@/components/user/GetReferee.vue';
import Product from '@/components/product/Product';

export default {
  components: {
    Coupon,
    Pickup,
    Upload,
    Uediter,
     GetUser,
    /*选择商品组件*/
    Product,
  },
  data() {
    return {

      /*产品去重*/
      excludeIds: [],

      isproduct:false,
      /*form表单数据*/
      form: {
        /*优惠券ID*/
        coupon_id:'',
        /*优惠券名称*/
        name:'',
        /*优惠券颜色*/
        color:'',
        /*优惠券类型*/
        coupon_type:'',
        /*减免金额*/
        reduce_price:'',
        /*折扣率*/
        discount:'',
        /*最低消费金额*/
        min_price:'',
        /*到期类型*/
        expire_type:'',
        exchange_type: '',
        exchange_time:'',
        /*有效天数*/
        expire_day:'',
        /*有效期*/
        active_time:'',
        is_share:0,
        is_order_give:0,
           //是否开启消耗额度
        is_open_ed:0,
        /*发放量*/
        total_num:'',
        /*排序*/
        sort: 1,
        /*商品源数据*/
        products: [],
        /*商品列表*/
        product_list: [],
        product_del_ids: [],
        // 优惠券背景图
        bg_image: 0,
        bgImage: null,
        // 优惠券分享图片
        share_image: 0,
        shareImage: null,
        exchange_bg: '',
        // 优惠券使用说明
        content: '',
        // 使用次数
        usage_count: 1,
        price:0,
        nprice:0,
           min_recive:1,
      },
      list: {},
      /*是否正在加载*/
      loading: true,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      // 背景图上传开关
      isBgUpload: false,
      bg_type:'',
      /*富文本框配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
       /*获取用户是否显示*/
      open_getuser: false,
       /*选择的用户列表*/
      referee:'',
    };
  },
  created() {
    let coupon_id = this.$route.query.coupon_id;
    this.getData(coupon_id);
  },
  methods: {
        /*关闭弹窗*/
    closeDialogFunc(e) {
      console.log(e)
      let self = this;
      self.isproduct = false;
      if (e.type === 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          let obj = {
            product_name: item.product_name,
            product_id: item.product_id,
            product_price: item.product_price,
            product_image: item.product_image
          };
          arr.push(obj);
        }
        self.form.products = self.form.products.concat(arr);
        self.form.products = mergeTable(this.form.products);
      }
    },
        /*打开添加*/
    changeProduct(list) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_id);
      });
      this.excludeIds = arr;
      this.isproduct = true;
    },
     // 删除用户
    deleteReferee(){
      this.referee = '';
      this.form.user_referee_id = 0;
    },
    deleteClick(index){
      this.form.products.splice(index,1); 
    },
     /*打开获取用户*/
    openGetuser() {
      this.open_getuser = true;
    },

    /*关闭获取用户*/
    closeGetuserFunc(e) {
      if (e.type != 'error') {
        this.referee=e.params[0];
         this.form.user_referee_id = e.params[0].user_id;
      }
      this.open_getuser = false;
    },
    getData(coupon_id) {
      let self = this;
      CouponApi.couponDetail(
        {
          coupon_id: coupon_id
        },
        true
      )
        .then(data => {
          let obj = data.data.detail;
          //选中
          obj.color = data.data.detail.color.value;
          obj.coupon_type = data.data.detail.coupon_type.value;
          // obj.pickupCardProduct = data.data.detail.pickupCardProduct
          console.log(data.data.detail)
          self.form = formatModel(self.form, obj);
          self.form.products = []
          if(data.data.detail.products && data.data.detail.products.length > 0) {
            self.form.products = mergeTable(data.data.detail.products)
          }
          self.form.product_del_ids = []
          self.loading=false;
          self.referee = data.data.detail.referee;
        })
        .catch(error => {
          self.loading=false;
        });
    },
    /*修改*/
    onSubmit() {
      let self = this;
      let form = self.form;
    
  
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          form.products = JSON.stringify(form.products);
          console.log(form)
          CouponApi.editCoupon(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，修改成功',
                type: 'success'
              });
              self.$router.push('/plus/coupon/index');
            })
            .catch(error => {
              self.loading = false;
            });
        } else {
          self.loading = false;
        }
      });
    },
    /*表格数据格式化*/
    tableFormat(list) {
      let spec_list = [];
      let newList = [];
      let curItem = null;
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let obj = {
          product_sku_id: item.product_sku_id,
          assemble_stock: item.assemble_stock,
          assemble_price: item.assemble_price,
          product_attr: item.spec_name,
          assemble_product_sku_id:item.assemble_product_sku_id,
          product_price:item.product_price,
          sales_initial:item.sales_initial
        };
        if (curItem == null) {
          curItem = item;
        }
        if (curItem.product_id != item.product_id) {
          curItem.spec_list = spec_list;
          newList.push(curItem);
          curItem = item;
          spec_list = [];
        }
        spec_list.push(obj);
      }
      if (curItem && curItem.spec_list) {
        curItem.spec_list = spec_list
      }
      curItem && newList.push(curItem);
      return newList;
    },
    /*取消*/
    cancelFunc(){
      this.$router.push({
        path:'/plus/coupon/index',
      });
    },
    // 上传详情附加图
    returnBgImgFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true;
              return false
            }
          });
        });
        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }
        console.log(this.bg_type)
        console.log(e[0])
        if(this.bg_type=='bg'){
          this.form.bgImage = e[0]
           this.form.bg_image = e[0].file_id
        }else{
          if(this.bg_type=='exchange_bg'){
            // exchange_bg file_path
            this.form.exchange_bg = e[0].file_path
          }else{
            this.form.shareImage = e[0]
            this.form.share_image = e[0].file_id
          }
        }
      }
      this.isBgUpload = false
    },
    bgUpload(bg_type) {
      this.bg_type = bg_type;
      console.log(this.bg_type)
      this.isBgUpload = true
    },
    deleteBgImg(bg_type) {
      if(bg_type=='bg'){
        this.form.bg_image = 0
        this.form.bgImage = null
      }else{
        if(this.bg_type=='exchange_bg'){
          // exchange_bg file_path
          this.form.exchange_bg = ''
        }else{
          this.form.share_image = 0
          this.form.shareImage = null
        }
      }
    },
    /*获取富文本框内容*/
    getContent: function() {
      //return this.$refs.ue.getUEContent();
    },
    /*获取富文本内容*/
    contentChangeFunc(e) {
      this.form.content = e;
    }
  }
};
</script>

<style lang="scss" scoped>
.product-add {
  padding-bottom: 50px;
}

.tips {
  color: #ccc;
}
.img-select {
  position: relative;
  width: 110px;
  height: 110px;
  margin-right: 10px;
  i {
    display: flex;
    line-height: 110px;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px dashed #dddddd;
    font-size: 30px;
    color: #409eff;
  }
}
.image-box {
  width: 110px;
  height: 110px;
  overflow: hidden;
  img {
    width: 110px;
    //height: 110px;
  }
}
.image-box:hover .delete-btn {
  display: block;
}
.default-image-box {
  position: relative;
  width: 110px;
  height: 110px;
}
.delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/coupon/coupon/edit.vue